import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.hook";

interface ProtectedRouteProps {
    requiredRole?: string;
}

const ProtectedRoute = ({ requiredRole }: ProtectedRouteProps) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>
    }

    if (!user) {
        return <Navigate to="/login" />
    }

    if (requiredRole && !user.roles.includes(requiredRole)) {
        return <Navigate to="/inicio" />
    }

    return (
        <Outlet />
    )
}

export default ProtectedRoute;